var _rect, _path, _g, _path2, _g2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFuterImg4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 142,
    viewBox: "0 0 106 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 16,
    width: 74,
    height: 121,
    rx: 10,
    fill: "url(#paint0_linear_222_107)",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_222_107",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 0,
    width: 74,
    height: 121
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.467 0H42.3771C39.7505 -2.24999e-06 37.2313 1.04252 35.3727 2.89861C33.5142 4.7547 32.4684 7.27255 32.465 9.89917V15.6986H66.9889C69.6156 15.6986 72.1348 16.7411 73.9933 18.5972C75.8518 20.4533 76.8977 22.9712 76.9011 25.5978V120.308H95.467C98.0914 120.305 100.607 119.261 102.463 117.405C104.319 115.549 105.363 113.034 105.366 110.409V9.89917C105.363 7.27479 104.319 4.75892 102.463 2.90321C100.607 1.04749 98.0914 0.00343281 95.467 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_222_107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.8552 0H40.976C36.2755 0 32.465 3.8105 32.465 8.51098V111.823C32.465 116.524 36.2755 120.334 40.976 120.334H96.8552C101.556 120.334 105.366 116.524 105.366 111.823V8.51098C105.366 3.8105 101.556 0 96.8552 0Z",
    fill: "url(#paint1_linear_222_107)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M68.4775 16H12.5225C7.81566 16 4 19.8316 4 24.5581V128.442C4 133.168 7.81566 137 12.5225 137H68.4775C73.1843 137 77 133.168 77 128.442V24.5581C77 19.8316 73.1843 16 68.4775 16Z",
    fill: "url(#paint2_linear_222_107)",
    stroke: "url(#paint3_linear_222_107)",
    strokeWidth: 1.16,
    strokeMiterlimit: 10
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_222_107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.3903 16H13.511C8.8105 16 5 19.8105 5 24.511V127.823C5 132.524 8.8105 136.334 13.511 136.334H69.3903C74.0907 136.334 77.9012 132.524 77.9012 127.823V24.511C77.9012 19.8105 74.0907 16 69.3903 16Z",
    fill: "url(#paint4_linear_222_107)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3903 16H13.511C8.8105 16 5 19.8105 5 24.511V127.823C5 132.524 8.8105 136.334 13.511 136.334H69.3903C74.0907 136.334 77.9012 132.524 77.9012 127.823V24.511C77.9012 19.8105 74.0907 16 69.3903 16Z",
    stroke: "url(#paint5_linear_222_107)",
    strokeWidth: 1.16,
    strokeMiterlimit: 10,
    shapeRendering: "crispEdges"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9012 37.4585H5V38.717H77.9012V37.4585Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65 127.301H16V128.301H65V127.301Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.54 85.6968C36.0984 85.6988 35.6625 85.5965 35.2679 85.3981C34.8734 85.1996 34.5313 84.9108 34.2696 84.5551L25.3694 72.6578C24.968 72.0514 24.8133 71.3146 24.9369 70.5979C25.0604 69.8812 25.4528 69.2387 26.034 68.8016C26.6152 68.3645 27.3413 68.1657 28.0641 68.2458C28.7869 68.3259 29.4519 68.6789 29.9232 69.2327L36.4881 77.9902L53.0171 53.6638C53.2266 53.3546 53.495 53.0897 53.807 52.8842C54.119 52.6787 54.4683 52.5366 54.8352 52.4661C55.202 52.3957 55.5792 52.3981 55.9451 52.4734C56.311 52.5487 56.6584 52.6953 56.9677 52.9048C57.2769 53.1144 57.5418 53.3828 57.7473 53.6948C57.9528 54.0067 58.0949 54.3561 58.1654 54.7229C58.2358 55.0898 58.2334 55.4669 58.1581 55.8328C58.0828 56.1987 57.9362 56.5462 57.7267 56.8554L38.9662 84.4902C38.716 84.8752 38.3766 85.1942 37.9768 85.42C37.577 85.6459 37.1287 85.772 36.6698 85.7876L36.54 85.6968Z",
    fill: "url(#paint6_linear_222_107)",
    stroke: "white",
    strokeWidth: 0.97,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_222_107",
    x: 0.420044,
    y: 12.4199,
    width: 82.0612,
    height: 129.495,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_222_107"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_222_107",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_222_107",
    x1: 42,
    y1: 16,
    x2: 42,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8253D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D05DDE",
    stopOpacity: 0.35
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_222_107",
    x1: 105.405,
    y1: 123.357,
    x2: 15.6636,
    y2: -32.0719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF16BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552083,
    stopColor: "#8253D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_222_107",
    x1: 40.4935,
    y1: 31.6028,
    x2: 40.4935,
    y2: 175.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "white",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_222_107",
    x1: 40.4935,
    y1: 15.2433,
    x2: 40.4935,
    y2: 137.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#D2D2D2",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#DDDDDD",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#DCDCDC",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#D5D5D5",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#CACACA",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#C7C7C7",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.08
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_222_107",
    x1: 41.4441,
    y1: 31.517,
    x2: 41.4441,
    y2: 174.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "white",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_222_107",
    x1: 41.4441,
    y1: 15.2475,
    x2: 41.4441,
    y2: 137.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#D2D2D2",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#DDDDDD",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#DCDCDC",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#D5D5D5",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#CACACA",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#C7C7C7",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.08
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_222_107",
    x1: 39.9522,
    y1: 60.4752,
    x2: 50.2147,
    y2: 78.2497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "white",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuterImg4);
export default __webpack_public_path__ + "static/media/futer_img4.9350a283a19cfcc34f59eb2ca03b206e.svg";
export { ForwardRef as ReactComponent };